import { terriEnum } from 'src/app/more/territory/model/territoryEnum';
import {
    Component,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { AccountsHttpService } from '../../services/accounts.http.service';
import { TerriService } from 'src/app/more/territory/services/terriService';
import { LeadService } from 'src/app/leads/leadService';
import { RouteManagementService } from 'src/app/more/route-management/route-management.service';
import { PermissionService } from 'src/app/service/permission.service';
import { AppMainService } from 'src/app/app-main.service';
import { LeadHelper } from 'src/app/leads-v2/services/lead.helper';
import { AccountHelper } from 'src/app/accounts-v2/services/accounts.helper';
import { generateContactName } from '../../helpers/generate-contact-name.helper';
import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { isValidLatLng } from '../../helpers/location.helper';
import { AccountModuleId, LeadModuleId } from '../../constants/modules.constant';
import { ChannelN } from '../../models/channel.model';
import { ObjectNames } from 'src/app/shared/constants';
import { ReportsAllFiltersApplyModes, ReportsAllFiltersAppyModels, typeReportsAllFiltersApplyModes } from 'src/app/reports/models/reports-all-filter-appy.models';
import { TerritoryMapObjects } from 'src/app/more/territory/model/territory-map-objects.model';
import { RootReducerState } from '../../stores/ngrx.imports';
import { Store } from '@ngrx/store';
import { selectorTerritoryMapAllData } from '../../stores/territoryMapDataStore/territoryMapData.selectors';
import { TerritoryMapFiltersModels } from 'src/app/models/territory-map/territory-map-filters.model';
import { getTerritoryMapStoredData } from '../../stores/territoryMapDataStore/territoryMapData.compare';
import { TerritoryMapRequestAction, TerritoryMapSuccessAction } from '../../stores/territoryMapDataStore/territoryMapData.actions';
import { DATE_RANGE_LIST } from '../../constants/date-range-list.constants';
import * as moment from 'moment';
import { TerritoryMapStoreModels } from '../../stores/territoryMapDataStore/territoryMapData.state';
import { DataService } from 'src/app/reports/dataService';

declare var google: any;

@Component({
    selector: 'app-dashboard-territory-map',
    templateUrl: './dashboard-territory-map.component.html',
    styleUrls: ['./dashboard-territory-map.component.scss'],
    providers: [LocalDatePipe]
})
export class DashboardTerritoryMapComponent implements OnInit, OnChanges, OnDestroy {

    @Input() mapNumber: number = 0;
    @Input() dashboardView: string = '';
    @Input() displayFilterPopup: boolean = false;
    @Input() selectedWindow: string = '';
    @Input() territoryNamesList = [];
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();

    reportsFilterApplyMode: typeReportsAllFiltersApplyModes | "" = "";

    //territory map
    territoryMap: any;
    mapInfoWindow: any;
    territoryMapMarkers: any[] = [];
    assignedMapOjectData: any;

    accountsChannelList: ChannelN[] = [];
    channelList: ChannelN[] = [];
    selectedChannel: ChannelN;
    selectedTerritory: any = null;
    columnsForMapView: any[] = [];
    reportsData = [];
    reportsDataCopy = [];

    territoryMapLoading: boolean = false;
    reportsDataLoaded: boolean = false;
    loadReportsFirstTime: boolean = false;
    selectedDateFilter: any = null;

    @Input() dateFrom: any;
    @Input() dateTo: any;

    @Input() selectedReportFilters: TerritoryMapFiltersModels;

    constructor(public _ngZone: NgZone,
        private permissionService: PermissionService,
        private appMainService: AppMainService,
        private leadHelper: LeadHelper,
        public routeManagementService: RouteManagementService,
        private terriService: TerriService,
        public localDatePipe: LocalDatePipe,
        private leadService: LeadService,
        private accountsHttpService: AccountsHttpService,
        private accountHelper: AccountHelper,
        private dataService: DataService,
        private store: Store<RootReducerState>
    ) {

    }

    async ngOnInit() {
        this.territoryMapLoading = true;
        this.accountsChannelList = await this.dataService.getAccountChannelList();
        this.territoryMapLoading = false;
        window[`cpntRef_${this.mapNumber}`] = { component: this, zone: this._ngZone };
        this.loadChartDataOnly();
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes?.displayFilterPopup && changes.displayFilterPopup?.currentValue) {
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue || false;
            this.setSelectedFilters(true);
        }

        if (changes?.reloadContent && changes?.reloadContent?.currentValue) {
            this.reloadContent = true;
            this.loadChartDataOnly();
        }

        if (changes?.selectedReportFilters && changes?.selectedReportFilters?.currentValue) {
            this.selectedReportFilters = changes?.selectedReportFilters?.currentValue;
            if (this.loadReportsFirstTime) this.setSelectedFilters();
        }
    }

    loadChartDataOnly() {
        this.loadReportsFirstTime = true;
        this.reportsData = [];
        this.setSelectedFilters();
        this.setAddedFilters();
        this.territoryReport();
    }

    setSelectedFilters(loadTerritoryList: boolean = false) {
        this.selectedTerritory = {
            id: this.selectedReportFilters?.selectedTerritoryId
        }
        if (this.selectedReportFilters?.dateFilter) {
            this.selectedDateFilter = {
                label: this.selectedReportFilters.dateFilter,
                code: this.selectedReportFilters.dateFilter,
                fromDate: this.selectedReportFilters?.fromDate || null,
                toDate: this.selectedReportFilters?.toDate || null
            }
        }

        this.selectDefaultChannel(this.selectedReportFilters?.accountChannelId || 0, loadTerritoryList);
    }

    //#region territory map

    async initTerritoryMap(addedFilters: TerritoryMapFiltersModels, fromStore: boolean = false, territoryId: number) {
        const { Map } = await google.maps.importLibrary('maps');

        var mapOptions = {
            zoom: 10,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            disableDefaultUI: false,
            draggable: true,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            panControl: true,
            streetViewControl: true,
            overviewMapControl: true,
            mapTypeControl: true,
            scaleControl: true,
            rotateControl: true,
            fullscreenControl: true,
            mapId: '656915a1a1b695a4',
        };

        this.territoryMap = new Map(document.getElementById(`map-${this.mapNumber}`), mapOptions);
        // const globalThis = this;
        // let geocoder = new google.maps.Geocoder();
        // geocoder.geocode({}, function (results, status) {
        //     if (status == google.maps.GeocoderStatus.OK) {
        //         let lat = results[0].geometry.location.lat;
        //         let lng = results[0].geometry.location.lng;

        //         globalThis.territoryMap.setCenter(results[0].geometry.location);
        //         globalThis.territoryMap.fitBounds(results[0].geometry.viewport);
        //     }
        // });

        if(fromStore){
            this.addMarkers(this.territoryMap, this.reportsData);
        }else{
            this.setTerritoryMapMarkers(addedFilters?.selectedTerritoryId, this.territoryMap, addedFilters);
        }

        this.highlightTerritoryArea(territoryId, this.territoryMap);
    }

    async highlightTerritoryArea(territoryId: number, territoryMap: any){
        const territoryDetails = await this.terriService.getTerrioryById(territoryId).catch(error=> null);
        if(!territoryDetails) return;

        const addresses: any[] = [];
        const stateAddresses: any[] = [];
        const countryName = territoryDetails.countryName;

        if (territoryDetails?.territoryRule?.length > 0) {
            const stateRules = territoryDetails?.territoryRule.find(element => element.equation=='is' && element.criteria.toLowerCase() == terriEnum.state);
            const cityRules = territoryDetails?.territoryRule.find(element =>  element.equation=='is' && element.criteria.toLowerCase() == terriEnum.city);
            const zipcodeRules = territoryDetails?.territoryRule.filter(element =>  element.equation=='is' && element.criteria.toLowerCase() == 'zipcode');

            if(zipcodeRules && zipcodeRules.length>0){
                zipcodeRules.map(zipRules=>{
                    zipRules?.territoryRuleDetail.map(ruleDetails=>{
                       (ruleDetails?.cityName && ruleDetails?.stateName) && addresses.push({
                            address: `${ruleDetails.value}, ${ruleDetails?.cityName}, ${ruleDetails?.stateName}, ${countryName}`,
                            locality: "POSTAL_CODE"
                        });
                    })
                })
            }else if(cityRules && cityRules?.territoryRuleDetail?.length>0){
                cityRules?.territoryRuleDetail.map(ruleDetails=>{
                    addresses.push({
                        address: `${ruleDetails.value}, ${ruleDetails?.stateName}, ${countryName}`,
                        locality: "LOCALITY"
                    });
                })
            }

            if(stateRules && stateRules?.territoryRuleDetail?.length>0){
                stateRules.territoryRuleDetail.map(ruleDetails=>{
                    stateAddresses.push({
                        address: `${ruleDetails?.stateNameDescription||ruleDetails.value}, ${countryName}`,
                        locality: "ADMINISTRATIVE_AREA_LEVEL_1"
                    });
                })
            }
        }

        this.setTerritoryMap(territoryDetails,addresses,stateAddresses,territoryMap);
    }

    async setTerritoryMap(territoryDetails: any, addresses: any[], stateAddresses: any[],territoryMap: any){
        const globalThis = this;
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode( { 'address': territoryDetails.countryName}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if(results[0]?.place_id){
                    globalThis.colorFeatureLayer(territoryMap,[results[0]?.place_id],'COUNTRY','#810FCB',0.1)
                }
            }
        });

        if(addresses?.length>0){
            const placeIds = [];
            addresses.map(async (address,index)=>{
                await geocoder.geocode( { 'address': address.address}, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if(results[0]?.place_id){
                            placeIds.push(results[0]?.place_id);
                            globalThis.colorFeatureLayer(territoryMap,placeIds,address.locality);
                        }
                    }
                });
            })
        }

        if(stateAddresses?.length>0){
            const placeIds = [];
            stateAddresses.map(async (address,index)=>{
                await geocoder.geocode( { 'address': address.address}, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if(results[0]?.place_id){
                            placeIds.push(results[0]?.place_id);
                            const color = addresses?.length==0 ? "" : "#ff5a26";
                            const opacity = addresses?.length==0 ? 0.3 : 0.1;
                            globalThis.colorFeatureLayer(territoryMap,placeIds,address.locality,color,opacity);
                        }
                    }
                });
            })
        }

    }

    colorFeatureLayer(map: any,placeIds: string[], featureLayerName: string, fillColor: string = "", fillOpacity: number = 0.3) {
        //@ts-ignore
        // LOCALITY, ADMINISTRATIVE_AREA_LEVEL_1, COUNTRY
        const featureLayer = map?.getFeatureLayer(featureLayerName);
        // Define a style with Crafteur Orange fill and border.
        //@ts-ignore
        const featureStyleOptions: google.maps.FeatureStyleOptions = {
          strokeColor: "blue",
          strokeOpacity: 1.0,
          strokeWeight: 2.0,
          fillColor: "blue",
          fillOpacity: fillOpacity,
        };

        // Apply the style to a single boundary.
        //@ts-ignore
        featureLayer.style = (options: { feature: { placeId: string } }) => {
          if (placeIds.includes(options.feature.placeId)) {
            const findIndex = placeIds.findIndex(p=> p==options.feature.placeId);
            const color = fillColor||this.getColor(findIndex);
            featureStyleOptions.strokeColor = color;
            featureStyleOptions.fillColor = color;
            return featureStyleOptions;
          }
        };
    }

    getColor(index){

        const colorList = ['#42A5F5','#66BB6A','#FFA726','#c2579b','#26A69A',"#FF6384","#36A2EB"];

        if(index>6){
            let i = index%6;
            return colorList[i];
        }else{
            return colorList[index];
        }
    }

    addMarkers(map, allObjects: TerritoryMapObjects[]) {
        // Create an info window to share between markers.
        this.mapInfoWindow = new google.maps.InfoWindow();
        let bounds = new google.maps.LatLngBounds();
        let markerCount = 0;
        //this.clearAllMarkers();
        allObjects.map((objectDetails, index) => {
            let markerLatLng = {
                lat: objectDetails.latitude,
                lng: objectDetails.longitude,
            }

            if (isValidLatLng(markerLatLng.lat, markerLatLng.lng)) {
                markerCount++;
                bounds.extend(markerLatLng);
                const advancedMarkerView = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    content: this.buildContent(objectDetails),
                    position: markerLatLng,
                    title: objectDetails.businessName
                });

                advancedMarkerView.addListener('click', () => {
                    this.getObjectDetails(advancedMarkerView, objectDetails);
                    const content = `<div class="map-marker-details-wrapper">
                                    <div class="marker-details-header">
                                        <h5>${objectDetails.businessName}</h5>
                                        <span class="close-icon pi pi-times" onclick="window.cpntRef_${this.mapNumber}.zone.run(() => {window.cpntRef_${this.mapNumber}.component.closeInfoWindow();})"></span>
                                    </div>
                                    <div class="marker-details-body">
                                        <div class="map-loader-wrapper">
                                            <div class="map-details-loader"></div>
                                        </div>
                                    </div>
                                </div>`;
                    this.mapInfoWindow.close();
                    this.mapInfoWindow.setContent(content);
                    this.mapInfoWindow.open(advancedMarkerView.map, advancedMarkerView);
                });

                this.territoryMapMarkers.push(advancedMarkerView);
            }
        });

        if (bounds) {
            map.fitBounds(bounds);
            map.setCenter(bounds.getCenter());
        }
    }

    buildContent(objectDetails: any) {
        const content = document.createElement('div');

        content.classList.add('map-marker');
        content.innerHTML = `
        <div class="marker-wrapper">
            <div class="icon">
                <div class="marker-pin" style="--marker-color: ${objectDetails?.stageColor || '#3381CC'
            }"></div>
            </div>
        </div>
      `;
        return content;
    }

    getObjectDetails(advancedMarkerView: any, objectDetails: TerritoryMapObjects) {

        if (objectDetails.objectTypeId == AccountModuleId) {
            this.accountsHttpService.getAccountDetails(objectDetails.accountId).subscribe(resp => {
                this.setLeadAccountMapDetails(resp, advancedMarkerView, objectDetails);
            }, (error) => {
                this.setLeadAccountMapDetails(null, advancedMarkerView, objectDetails);
            });
        } else if (objectDetails.objectTypeId == LeadModuleId) {
            this.leadService.getLeadDetailsById(objectDetails.accountId).then(resp => {
                this.setLeadAccountMapDetails(resp, advancedMarkerView, objectDetails);
            }).catch((err) => {
                this.setLeadAccountMapDetails(null, advancedMarkerView, objectDetails);
            });
        }

    }

    setLeadAccountMapDetails(account: any, advancedMarkerView: any, objectDetails: TerritoryMapObjects) {

        let detailsList: string = "";

        if (!account) {
            detailsList = `<p class="p-text-center">Details Not Found! Please try again...</p>`;
        } else {
            let contactName: string = "";
            let primaryContact = null;
            let selectedAddress = null;
            let formattedAddress = null;
            let responseData = null;

            if (objectDetails?.objectTypeId == AccountModuleId) {
                if (account.accountContacts?.length && account.accountContacts[0] && account.accountContacts[0].contact) {
                    const contactDetails = account.accountContacts[0].contact;
                    contactName = generateContactName(contactDetails);
                }

                const data = {
                    ...account,
                    contactName: contactName,
                    accountStatus: account.accountStatus?.name || "",
                    accountCategory: null,
                    accountTypesNames: account.accountTypes?.length ? this.accountHelper.processAccountNames(account.accountTypes) : null,
                    stageId: null,
                    statusName: account.status ? account.status.name : null
                };

                responseData = this.accountHelper.processAccountDetailsData(data);

                primaryContact = responseData.accountContacts?.length > 0 ? responseData.accountContacts.find(contact => contact.isPrimaryContact) || responseData.accountContacts[0] : null;
                selectedAddress = responseData.accountAddresses?.length > 0 ? responseData.accountAddresses.find(address => address?.address?.latitude == objectDetails.latitude && address?.address?.longitude == objectDetails.longitude) : null;
                formattedAddress = selectedAddress?.address ? this.formattedAddress(selectedAddress?.address) : null;
                responseData['address'] = formattedAddress;
            } else if (objectDetails?.objectTypeId == LeadModuleId) {
                responseData = this.leadHelper.processLeadDetailsData(account);
                primaryContact = responseData.leadContacts?.length > 0 ? responseData.leadContacts.find(contact => contact.isPrimaryContact) || responseData.leadContacts[0] : null;
                selectedAddress = responseData.leadAddresses?.length > 0 ? responseData.leadAddresses.find(address => address?.address?.latitude == objectDetails.latitude && address?.address?.longitude == objectDetails.longitude) : null;
                formattedAddress = selectedAddress?.address ? this.formattedAddress(selectedAddress?.address) : null;
                responseData['address'] = formattedAddress;
                if (primaryContact?.contact) {
                    primaryContact['contactName'] = contactName = generateContactName(primaryContact.contact);
                }
            }

            if (responseData?.businessName) {
                detailsList = detailsList.concat(`
                <div class="marker-details-list">
                    <div class="marker-details-label">${objectDetails?.objectTypeId == LeadModuleId ? 'Lead' : 'Account'} Name</div>
                    <div class="marker-details-info">${responseData?.businessName}</div>
                </div>
            `);
            }

            if (responseData?.sequenceNumber) {
                detailsList = detailsList.concat(`
                <div class="marker-details-list">
                    <div class="marker-details-label">${objectDetails?.objectTypeId == LeadModuleId ? 'Lead' : 'Account'} ID No.</div>
                    <div class="marker-details-info">${responseData?.sequenceNumber}</div>
                </div>
            `);
            }

            if (formattedAddress) {
                detailsList = detailsList.concat(`
                <div class="marker-details-list">
                    <div class="marker-details-label">Address</div>
                    <div class="marker-details-info">${formattedAddress}</div>
                </div>
            `);
            }

            if (primaryContact?.contact) {
                detailsList = detailsList.concat(`
                <div class="marker-details-list">
                    <div class="marker-details-label">Contact Name</div>
                    <div class="marker-details-info">${primaryContact?.contactName}</div>
                </div>
            `);
            }

            if (this.columnsForMapView?.length > 0) {
                this.columnsForMapView.filter(f => !['sequenceNumber', 'businessName', 'contactname', 'title', 'contactFirstName', 'contactLastName', 'contactMiddleName', 'description'].includes(f.columnName) && !f.isCustom).map(field => {

                    if (field?.columnName == 'tags' && responseData.tags?.length > 0) {
                        const tagsArray = responseData.tags.map(item => item.name);
                        responseData.tags = tagsArray.join(', ');
                    }

                    if (field?.columnName && responseData[field?.columnName]) {

                        if (field?.fieldDataType == 'DateTime') {
                            responseData[field?.columnName] = this.localDatePipe.transform(responseData[field?.columnName], 'date');
                        }


                        detailsList = detailsList.concat(`
                        <div class="marker-details-list">
                            <div class="marker-details-label">${field?.name}</div>
                            <div class="marker-details-info">${responseData[field?.columnName]}</div>
                        </div>
                    `);
                    }
                })
            } else {
                if (responseData?.classificatioName && objectDetails?.objectTypeId == AccountModuleId) {
                    detailsList = detailsList.concat(`
                    <div class="marker-details-list">
                        <div class="marker-details-label">Business Classification</div>
                        <div class="marker-details-info">${responseData?.classificatioName}</div>
                    </div>
                `);
                }

                if (responseData?.stageName && objectDetails?.objectTypeId == LeadModuleId) {
                    detailsList = detailsList.concat(`
                    <div class="marker-details-list">
                        <div class="marker-details-label">Stage</div>
                        <div class="marker-details-info">${responseData?.stageName}</div>
                    </div>
                `);
                }

                if (primaryContact?.contact) {
                    let phones: string = "";
                    primaryContact?.contact?.contactPhones?.filter(c => c?.phone?.statusId == 1).map(phoneDetails => {
                        if (phoneDetails?.phone?.number) {
                            phones = phones.concat(`<div>${phoneDetails?.phone?.number}</div>`);
                        }
                    });

                    if (phones) {
                        detailsList = detailsList.concat(`
                        <div class="marker-details-list">
                            <div class="marker-details-label">Contact Phones</div>
                            <div class="marker-details-info">${phones}</div>
                        </div>
                    `);
                    }

                    let emails: string = "";
                    primaryContact?.contact?.contactEmails?.filter(c => c?.email?.statusId == 1).map(emailDetails => {
                        if (emailDetails?.email?.emailAddress) {
                            emails = emails.concat(`<div>${emailDetails?.email?.emailAddress}</div>`);
                        }
                    });

                    if (emails) {
                        detailsList = detailsList.concat(`
                        <div class="marker-details-list">
                            <div class="marker-details-label">Contact Emails</div>
                            <div class="marker-details-info">${emails}</div>
                        </div>
                    `);
                    }
                }
            }

            //Details Formatting End
        }

        const content = `<div class="map-marker-details-wrapper">
                        <div class="marker-details-header">
                            <h5>${objectDetails.businessName}</h5>
                            <span class="close-icon pi pi-times" onclick="window.cpntRef_${this.mapNumber}.zone.run(() => {window.cpntRef_${this.mapNumber}.component.closeInfoWindow();})"></span>
                        </div>
                        <div class="marker-details-body">
                            <div class="marker-details-wrapper">
                                ${detailsList}
                            </div>
                        </div>
                    </div>`;
        this.mapInfoWindow.close();
        this.mapInfoWindow.setContent(content);
        this.mapInfoWindow.open(advancedMarkerView.map, advancedMarkerView);
    }

    formattedAddress(addressData: any) {
        let address = (addressData?.streetAddress1 ? addressData?.streetAddress1 + ', ' : '')
            + (addressData?.streetAddress2 ? addressData?.streetAddress2 + ', ' : '')
            + (addressData?.city?.name ? addressData?.city?.name + ', ' : '')
            + (addressData?.state?.name ? addressData?.state?.name + ', ' : '')
            + (addressData?.country?.name ? addressData?.country?.name + ', ' : '')
            + (addressData?.zipCode ? addressData?.zipCode : '');
        return address.trim().replace(/,\s*$/, "");
    }

    closeInfoWindow() {
        this.mapInfoWindow?.close();
    }
    //#endregion

    selectDefaultChannel(accountChannel: number = 0, loadTerritoryList: boolean = false) {
        this.channelList = this.permissionService.filterChannelsByPermissions(this.accountsChannelList, ObjectNames.TERRITORY);
        const accChannelExist = this.channelList.find(channel=>channel?.id==accountChannel);

        if(accChannelExist && accountChannel){
            this.selectedChannel = accChannelExist;
        }else{
            this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
        }

        loadTerritoryList && this.getAllTerritoryList(this.selectedChannel?.id, this.selectedReportFilters?.selectedTerritoryId);
    }

    getAllTerritoryList(selectedChannelId: number, selectedTerritoryId: number = 0) {
        this.appMainService.isShowSpinner('getAllTerritories');
        this.routeManagementService.getAllTerritoryies(selectedChannelId, true).subscribe({
            next: (response) => {
                const territoryTableData = this.addTerritoryLabel(response || []);
                this.territoryNamesList = JSON.parse(JSON.stringify(territoryTableData)) || [];

                const flattedTerritories = this.getFlatArrayFormChilren(this.territoryNamesList);
                if (selectedTerritoryId > 0) {
                    this.selectedTerritory = flattedTerritories.find(obj => obj.id == selectedTerritoryId) || null;
                }

                this.appMainService.isHideSpinner('getAllTerritories');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getAllTerritories');
            }
        })
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    // #region  ***method to modify data***
    addTerritoryLabel(originalData) {
        const convertedData = originalData.map((item) => {
            const { children, ...data } = item;
            const childrenData = this.addTerritoryLabel(children);
            return {
                ...data,
                label: data.name,
                children: childrenData,
            };
        });
        return convertedData;
    }

    closeFilterPopup() {
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit(false);
    }

    onChangeChannel(selectedChannel) {
        this.selectedTerritory = null;
        this.getAllTerritoryList(selectedChannel?.id);
    }

    allFiltersChanges(filterValues: ReportsAllFiltersAppyModels) {
        this.reportsFilterApplyMode = filterValues.applyMode;
        this.dateFrom = filterValues?.dateFilter?.fromDate || this.dateFrom;
        this.dateTo = filterValues?.dateFilter?.toDate || this.dateTo;
        this.selectedChannel = filterValues?.channel || this.selectedChannel;
        this.selectedTerritory = filterValues?.selectedTerritory || this.selectedTerritory;
        filterValues.accountChannel = this.selectedChannel;
        this.territoryReport();
        this.onUpdateAllFilters.emit(filterValues);
    }

    territoryReport() {
        const getReportsData = this.store.select(selectorTerritoryMapAllData);
        this.reportsData = [];
        this.reportsDataLoaded = false;
        this.territoryMapLoading = true;

        const addedFilters: TerritoryMapFiltersModels = {
            dateFilter: this.selectedDateFilter?.code,
            fromDateOnly: this.formatDate(this.dateFrom),
            toDateOnly: this.formatDate(this.dateTo),
            accountChannelId: this.selectedChannel?.id || 0,
            selectedTerritoryId: this.selectedTerritory?.id || null
        }

        getReportsData.subscribe(storedData => {
            const results = getTerritoryMapStoredData(storedData, this.selectedWindow, addedFilters);
            if (results.index > -1 && !this.reloadContent && this.reportsFilterApplyMode == "") {
                const updatedTime: Date = results?.data?.loadedTime ? new Date(results?.data?.loadedTime) : new Date();
                this.onLastReloadTime.emit(updatedTime);
                this.setReportsResponse(results?.data?.reportsData || [],this.selectedTerritory?.id);
            } else {
                this.reloadContent = false;
                this.loadNewReportsData(addedFilters);
            }
        });
    }

    setReportsResponse(responseData,territoryId: number) {
        this.reportsData = responseData;
        this.initTerritoryMap(null,true,territoryId);
        this.setReportsFinalResponse();
    }

    setReportsFinalResponse() {
        this.reportsDataLoaded = true;
        this.territoryMapLoading = false;
        this.onReloadContent.emit(false);
      }

    loadNewReportsData(addedFilters: TerritoryMapFiltersModels) {
        if (this.reportsFilterApplyMode != ReportsAllFiltersApplyModes.applyOnly) {
            this.store.dispatch(new TerritoryMapRequestAction());
        }
        this.initTerritoryMap(addedFilters,false,addedFilters?.selectedTerritoryId);
    }

    setTerritoryMapMarkers(territoryId: number, map?: any, addedFilters?: TerritoryMapFiltersModels) {
        if (territoryId) {
            this.terriService.getTerritoryMapObjects(territoryId).subscribe({
                next: (response: TerritoryMapObjects[]) => {
                    this.assignedMapOjectData = response;
                    this.reportsData = this.assignedMapOjectData;
                    if (response?.length > 0) {
                        const updatedTime: Date = new Date();
                        this.onLastReloadTime.emit(updatedTime);
                        this.setReportsResponse(this.reportsData,territoryId);
                        if (this.reportsFilterApplyMode != ReportsAllFiltersApplyModes.applyOnly) {
                            this.setTerritoryMapStoreData(this.reportsData, addedFilters);
                        }

                        this.reportsFilterApplyMode = "";
                        this.addMarkers(map, this.reportsData);
                    }
                },
                error: (error) => {

                },
                complete: () => {
                    this.setReportsFinalResponse();
                }
            })
        }
    }

    setTerritoryMapStoreData(results: any, addedFilters: TerritoryMapFiltersModels) {
        const reportsData: TerritoryMapStoreModels = {
            reportsData: results,
            reportType: this.selectedWindow,
            loadedTime: new Date(),
            addedFilters: addedFilters,
            loading: false,
            loaded: true
        }

        this.store.dispatch(new TerritoryMapSuccessAction(reportsData));
    }

    setAddedFilters() {
        const addedDateRange = DATE_RANGE_LIST.find(range => range.code == this.selectedReportFilters.dateFilter);
        const filterValues: ReportsAllFiltersAppyModels = {
            applyMode: ReportsAllFiltersApplyModes.applyOnly,
            dateFilter: {
                ...addedDateRange,
                fromDate: this.dateFrom,
                toDate: this.dateTo
            },
            accountChannel: this.selectedChannel,
            selectedTerritory: this.selectedTerritory
        }

        this.onUpdateAllFilters.emit(filterValues);
    }

    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }

    ngOnDestroy(): void {
        window[`cpntRef_${this.mapNumber}`] = null;
    }
}
